import { render, staticRenderFns } from "./Cabinet.vue?vue&type=template&id=535c3623&"
import script from "./Cabinet.vue?vue&type=script&lang=js&"
export * from "./Cabinet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports